import { Input } from '@/src/components/Antd';
import { get } from 'lodash';
import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field, antdErrorDisplayAdaptor } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { imageName } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
const ImageCarouselName = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPoster, validator, breakpoint, disabled } = props;
  const nameValidator = get(validator, 'name');
  return (
    <Section {...sectionProps}>
      <ItemWrapper
        title={
          isPoster
            ? getI18n('salesChannelContent.index.posterName')
            : getI18n('salesChannelContent.index.carouselName')
        }
        size='small'>
        <Field
          name={imageName}
          rules={[
            {
              // validateTrigger: 'onSubmit',
              validator: async (rules: any, value: any) => {
                if (nameValidator) {
                  const res = nameValidator(value, { breakpoint });

                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, m) => {
            const eP = antdErrorDisplayAdaptor(m);

            return (
              <Input
                maxLength={100}
                size='large'
                {...props}
                {...m}
                {...eP}
                disabled={disabled}
              />
            );
          }}
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default ImageCarouselName;
